module.exports = __webpack_public_path__ + "img/MLW_IV.b8d43de1.svg";